import type { IothubEvent } from './useIothubHub';
import { RosbridgeHubEvents } from './useRosbridgeHub';
import { SpotcontrolHubEvents } from './useSpotcontrolHub';
import { TelemetryHubEvents } from './useTelemetryHub';
import { TeleoperationHubEvents } from './useTeleoperationHub';
import { TwinHubEvents } from './useTwinHub';

/**
 * All available topics for all hubs
 */
export type MethodName =
  | TelemetryHubEvents
  | IothubEvent
  | TeleoperationHubEvents
  | SpotcontrolHubEvents
  | RosbridgeHubEvents
  | TwinHubEvents;

export enum HUB_URL {
  TELEMETRY = 'telemetry',
  TELEOPERATION = 'teleoperation',
  SPOTCONTROL = 'spotcontrol',
  IOTHUB = 'iothub',
  ROSBRIDGE = 'rosbridge',
  TWIN = 'hub/twin',
}

export const HUB_URLS = Object.values(HUB_URL);
